import "./message.scss";

const Message = ({own}) => {
  return (
    <div className={own ? "message own" : "message"}>
      <div className="messageTop">
        <img 
          src="https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" 
          alt="" 
        />
        <p>"This is a test for message for seeing what different messages look like with various lengths"</p>
      </div>
      <div className="messageBottom">
        1 hour ago
      </div>
    </div>
  );
};

export default Message;
